let Cart = {
    isNeedInitMindboxCart: true,
    /**
     * Контейнер для вывода сообщений
     */
    containerForMessage: null,
    /**
     * Основной блок - ввод и применение купона
     */
    containerToInsert: null,
    /**
     * Максимальное количество бонусов клиента, которое применимо к корзине (количество активных бонусов)
     */
    maxUserBonusToCart: null,
    /**
     * Инициализация блока полей ввода активации купона и/или применения бонусов
     */
    initBonusInput: function () {
        "use strict";

        const basketDataElement = document.querySelector(".js-basket-data");
        const wrapperBonusInputs = document.querySelectorAll(".js-bonus_input_wrapper");

        if (!!basketDataElement && !!wrapperBonusInputs) {
            // Создаем экземпляр класса XMLHttpRequest
            let request = new XMLHttpRequest();

            let formData = new FormData();

            // Доступно ли клиенту применение купона (зависит от товаров корзины)
            let isCanUseCoupon = "Y" === basketDataElement.dataset.isCanUseCoupon;

            // Доступно ли клиенту применение бонусов (зависит от товаров и от баланса бонусов)
            let isCanUseBonus = "Y" === basketDataElement.dataset.isCanUseBonus;

            if (isCanUseBonus && window.obMindbox.personal.isAuthUser && window.obMindbox.personal.bonusBalance) {
                isCanUseBonus = true;
            }

            // Доступно ли клиенту и применение купона, и применение бонусов
            let isCanUseBoth = isCanUseBonus && isCanUseCoupon;

            formData.append("isCanUseBoth", isCanUseBoth ? "Y" : "N");
            formData.append("isCanUseCoupon", basketDataElement.dataset.isCanUseCoupon);
            formData.append("isCanUseBonus", basketDataElement.dataset.isCanUseBonus);
            formData.append("isCouponSelected", basketDataElement.dataset.isCouponSelected);
            formData.append("isSpendBonusSelected", basketDataElement.dataset.isSpendBonusSelected);
            formData.append("userCouponCode", basketDataElement.dataset.userCouponCode);
            formData.append("maxUserBonusToCart", basketDataElement.dataset.maxUserBonusToCart);
            formData.append("userUsedBonus", basketDataElement.dataset.userUsedBonus);
            formData.append("currencySign", basketDataElement.dataset.currencySign);

            request.open("POST", "/ajax/basket/get_bonus_input.php", true);

            request.send(formData);

            request.onload = function () {
                if (request.readyState === 4 && request.status === 200) {
                    // Очищаем всё содержимое обёртки
                    wrapperBonusInputs.forEach(wrapper => {
                        window.obMindbox.clearElem(wrapper); // Передаём конкретный элемент в метод clearElem
                    });

                    // Вставляем новое содержимое
                    wrapperBonusInputs.forEach(wrapper => {
                        wrapper.insertAdjacentHTML("afterbegin", request.response);
                    });

                    // Инициируем переменные в области видимости модуля
                    Cart.containerForMessage = document.querySelector(".page--cart .flex-message");
                    Cart.containerToInsert = document.querySelector(".page--cart .right-coupon__item");

                    // Инициализация применения купона
                    Cart.initClickApplyCoupon();

                    // Инициализация отмены применения купона
                    Cart.initClickCancelCoupon();

                    // Инициализация применения бонусов
                    Cart.initClickApplyBonus();

                    // Инициализация отмены применения бонусов
                    Cart.initClickCancelBonus();

                    // Инициализация переключения вкладок Купон/Бонусы
                    Cart.initCartTabs();

                    // Инициализация очистки цвета ошибки в инпутах купона и бонусов
                    Cart.initChangeCouponInput();
                    Cart.initChangeBonusInput();
                }
            };
        }
    },
    /**
     * Инициализация блока информации по бонусам, которые будут начислены в случае исполнения заказа.
     */
    initBonusInfo: function () {
        "use strict";

        const basketDataElement = document.getElementsByClassName("js-basket-data")[0];
        const wrapperBonusInfo = document.getElementsByClassName("js-bonus_info_wrapper")[0];

        if (basketDataElement && wrapperBonusInfo) {
            // Создаем экземпляр класса XMLHttpRequest
            let request = new XMLHttpRequest();

            let formData = new FormData();

            formData.append("bonusToEarn", basketDataElement.dataset.bonusToEarn);
            formData.append("currencyCode", basketDataElement.dataset.currencyCode);
            formData.append("isCanEarnBonusPoints", basketDataElement.dataset.isCanEarnBonusPoints);
            formData.append("isUserAuthorized", basketDataElement.dataset.isUserAuthorized);
            formData.append("currencySign", basketDataElement.dataset.currencySign);

            request.open(
                "POST",
                "/ajax/basket/get_bonus_info.php",
                true
            );

            request.send(formData);

            request.onload = function () {
                if (request.readyState === 4 && request.status === 200) {
                    // Очищаем всё содержимое обёртки
                    window.obMindbox.clearElem(wrapperBonusInfo);

                    wrapperBonusInfo.insertAdjacentHTML("afterBegin", request.response);
                }
            };
        }
    },
    /**
     * Функция инициализирует обработку переключения вкладок на странице: [Купон / Бонусы], [Доставка / Самовывоз].
     */
    initCartTabs: function () {
        "use strict";

        const $allTabs = document.querySelectorAll(".cart__tabs");
        if (!!$allTabs) {
            $allTabs.forEach((tabsContainer) => {
                const tabsButtons = tabsContainer.querySelectorAll(".cart__tabs-button");
                const tabsContent = tabsContainer.querySelectorAll(".cart__tabs-tab");

                if (!!tabsButtons && !!tabsContent) {
                    Array.prototype.forEach.call(tabsButtons, function (button) {
                        if ("Y" !== button.dataset.initClick) {
                            // Кнопку ещё не инициализировали: приступаем.
                            button.addEventListener("click", Cart.cartTabClickHandler);
                        }
                    });
                }
            });
        }
    },
    cartTabClickHandler: function (event) {
        "use strict";

        if (!!event) {
            const button = event.target;
            const tabsContainer = window.mainJs.getClosest(button, "cart__tabs");
            let tabsButtons;
            let tabsContent;
            if (!!tabsContainer) {
                tabsButtons = tabsContainer.querySelectorAll(".cart__tabs-button");
                tabsContent = tabsContainer.querySelectorAll(".cart__tabs-tab");
            }
            if (!!button && !!tabsButtons && !!tabsContent) {
                // Помечаем кнопку-таб, как проинициализированную.
                // Это не даст несколько раз навесить обработку клика на одну и ту же кнопку.
                button.dataset.initClick = "Y";

                tabsButtons.forEach(
                    (btn) => btn.classList.remove("cart__tabs-button--active")
                );

                tabsContent.forEach((tab) => {
                    tab.style.display = "none";
                    tab.classList.remove("active", "first-active", "last-active", "middle-active");
                });

                button.classList.add("cart__tabs-button--active");
                const tabName = button.dataset.tab;
                if (tabName) {
                    let $activeTab = tabsContainer.querySelector(`.cart__tabs-tab[data-tab="${tabName}"]`);
                    if (!!$activeTab) {
                        $activeTab.style.display = "block";
                        $activeTab.classList.add("active");

                        if ($activeTab === tabsContent[0]) {
                            $activeTab.classList.add("first-active");
                        } else if ($activeTab === tabsContent[tabsContent.length - 1]) {
                            $activeTab.classList.add("last-active");
                        } else {
                            $activeTab.classList.add("middle-active");
                        }
                    }

                    // Отдельные проверки для вкладок Купона и Бонусов.
                    let selectedDiscountType = "";
                    if ("promo" === tabName) {
                        selectedDiscountType = "c";
                    } else if ("points" === tabName) {
                        selectedDiscountType = "b";
                    }
                    if (selectedDiscountType) {
                        Cart.changeDiscountTypeHandler(selectedDiscountType);
                    }
                }
            }
        }
    },
    /**
     * Функция инициализирует пересчёт корзины. Пересчёт выполняется на сервере.
     */
    initRecalcCart: function () {
        "use strict";

        return new Promise(function (resolve, reject) {
            let arRequestedPromotions = {
                "coupon": [],
                "bonus": []
            };
            const basketData = window.obMindbox.cart.getBasketData();
            if (basketData.userCouponCode) {
                arRequestedPromotions["coupon"] = [];
                arRequestedPromotions["coupon"].push(basketData.userCouponCode);
            }
            if (basketData.userUsedBonus) {
                arRequestedPromotions["bonus"] = {};

                let obBonusAccount = {};
                let bonusAccountCode = "";
                if (basketData.hasOwnProperty("bonusAccountCode") && basketData.bonusAccountCode) {
                    bonusAccountCode = basketData.bonusAccountCode;
                } else {
                    window.console.log("ERROR! No bonus account code");
                    bonusAccountCode = "MainBalance";
                }
                obBonusAccount[bonusAccountCode] = basketData.userUsedBonus;
                arRequestedPromotions["bonus"] = obBonusAccount;
            }

            window.obMindbox.cart.recalcCart(arRequestedPromotions, window.obMindbox.personal.mindboxUserId)
                .then(function (basketAfterRecalc) {
                    resolve(basketAfterRecalc);
                })
                .catch(function (error) {
                    reject(new Error(error));
                });
        });
    },
    /**
     * Функция выполняет пересчёт корзины в Mindbox. Пересчёт выполняется на сервере.
     * Там запрашиваются данные по текущей корзине пользователя в mindbox.
     * Если есть применение каких-то скидок, они применяются и приходит сигнал,
     * что требуется отобразить пользователю обновлённые данные корзины.
     *
     * @param {Object} obRequestedPromotions Массив данных с ключами: "coupons" и "bonuses".
     *                                       Значения - массив-перечисление купонов или бонусов по типам бонусных счетов
     * @param {Number|Null} mindboxUserId    Идентификатор пользователя по данным клиентской стороны
     */
    recalcCart: function (obRequestedPromotions, mindboxUserId) {
        "use strict";

        return new Promise(function (resolve, reject) {
            let request = new XMLHttpRequest();

            let formData = new FormData();

            formData.append("requestPromotions", JSON.stringify(obRequestedPromotions));

            let requestMindboxUserId = "";
            if (mindboxUserId > 0) {
                requestMindboxUserId = mindboxUserId.toString();
            }
            formData.append("mindboxUserId", requestMindboxUserId);

            request.open("POST", "/ajax/basket/recalc_mindbox_cart.php", true);

            request.responseType = "json";

            request.send(formData);

            request.onload = function () {
                if (request.readyState === 4 && request.status === 200) {
                    const jsonResponse = request.response;
                    if (jsonResponse.success) {
                        if (null !== jsonResponse.maxUserBonusToCart) {
                            // Запомним значение в глобальном объекте,
                            // чтобы потом можно было его извлечь после обновления блока корзины.
                            Cart.maxUserBonusToCart = jsonResponse.maxUserBonusToCart;

                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-max-user-bonus-to-cart",
                                jsonResponse.maxUserBonusToCart || ""
                            );
                        }
                        if (jsonResponse.isBasketChanged) {
                            // Установим новые данные
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-is-can-use-both",
                                jsonResponse.isCanUseBoth ? "Y" : "N"
                            );
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-is-can-use-coupon",
                                jsonResponse.isCanUseCoupon ? "Y" : "N"
                            );
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-is-can-use-bonus",
                                jsonResponse.isCanUseBonus ? "Y" : "N"
                            );
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-is-coupon-selected",
                                jsonResponse.isCouponSelected ? "Y" : "N"
                            );
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-is-spend-bonus-selected",
                                jsonResponse.isSpendBonusSelected ? "Y" : "N"
                            );

                            let firstUserCouponCode = jsonResponse.arUserCouponCodes[0];
                            if (!firstUserCouponCode) {
                                firstUserCouponCode = "";
                            }
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-user-coupon-code",
                                firstUserCouponCode
                            );

                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-user-used-bonus",
                                jsonResponse.userUsedBonus || ""
                            );

                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-is-can-earn-bonus-points",
                                jsonResponse.isCanEarnBonusPoints ? "Y" : "N"
                            );
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-is-user-authorized",
                                jsonResponse.isUserAuthorized ? "Y" : "N"
                            );
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-bonus-to-earn",
                                jsonResponse.bonusToEarn || ""
                            );
                            document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                "data-is-mindbox-bonus-program",
                                jsonResponse.isMindboxBonusProgram ? "Y" : "N"
                            );

                            window.obMindbox.personal.mindboxUserId = jsonResponse.mindboxUserId;
                        }

                        // Вывод сообщений в корзине
                        let basketMessagesBlock = document.getElementsByClassName("js-basket-messages")[0];
                        if (basketMessagesBlock) {
                            basketMessagesBlock.innerHTML = "";

                            if (jsonResponse.arBasketMessages) {
                                jsonResponse.arBasketMessages.forEach(function (message) {
                                    let newMessage = document.createElement("div");
                                    newMessage.classList.add("cart-gift-badge")
                                    newMessage.innerText = message;
                                    basketMessagesBlock.append(newMessage);
                                });
                            }
                        }

                        resolve(jsonResponse);
                    } else {
                        // Запрос выполнился, но там какие-то ошибки
                        reject(new Error("В результате запроса получены ошибки"));
                    }
                } else {
                    // Запрос не выполнился
                    reject(new Error("Запрос не выполнился. " + request.status + ": " + request.statusText));
                }
            }
        });
    },
    /**
     * Обработчик смены типа скидки (купон / бонусы). Нужно деактивировать инпут другого типа скидки.
     *
     * @param {string} selectedDiscountType Тип скидки, который сейчас выбран (открыта вкладка этого типа скидки).
     *                                      Возможны два значения: "b" - бонусы; "c" - купон
     */
    changeDiscountTypeHandler: function (selectedDiscountType) {
        "use strict";

        if ("b" === selectedDiscountType || "c" === selectedDiscountType) {
            const inputBonus = document.querySelectorAll(".js-bonus-input");
            const inputCoupon = document.querySelectorAll(".js-coupon-input");
            const btnApplyBonus = document.querySelectorAll(".js-set-bonus");
            const btnApplyCoupon = document.querySelectorAll(".js-set-coupon");
            if ("c" === selectedDiscountType) {
                // Выбрана возможность применить купон
                Array.prototype.forEach.call(inputBonus, function (inp) {
                    inp.disabled = true;
                });
                Array.prototype.forEach.call(inputCoupon, function (inp) {
                    inp.disabled = false;
                });
                Array.prototype.forEach.call(btnApplyBonus, function (btn) {
                    btn.disabled = true;
                });
                Array.prototype.forEach.call(btnApplyCoupon, function (btn) {
                    btn.disabled = false;
                });
            } else if ("b" === selectedDiscountType) {
                // Выбрана возможность применить бонусы
                Array.prototype.forEach.call(inputBonus, function (inp) {
                    inp.disabled = false;
                });
                Array.prototype.forEach.call(inputCoupon, function (inp) {
                    inp.disabled = true;
                });
                Array.prototype.forEach.call(btnApplyBonus, function (btn) {
                    btn.disabled = false;
                });
                Array.prototype.forEach.call(btnApplyCoupon, function (btn) {
                    btn.disabled = true;
                });
            }
            /*
            let divInputWrapper = document.querySelectorAll(".right-coupon__item-radioNext");
            Array.prototype.forEach.call(divInputWrapper, function (inpWrapper) {
                if (window.obMindbox.isHasClass(inpWrapper, "right-coupon__item_hidd")) {
                    inpWrapper.classList.remove("right-coupon__item_hidd");
                } else {
                    inpWrapper.classList.add("right-coupon__item_hidd");
                }
            });
            */
        }
    },
    /**
     * Функция добавляет обработчик кнопки применения купона.
     */
    initClickApplyCoupon: function () {
        "use strict";

        const btnApplyCoupon = document.querySelectorAll(".js-set-coupon");
        Array.prototype.forEach.call(btnApplyCoupon, function (btn) {
            btn.addEventListener("click", Cart.applyCouponHandler);
        });
    },
    /**
     * Обработчик применения купона.
     * Внимание! Рассчитано на то, что в разметке есть общий родительский элемент,
     * который включает в себя инпут и эту нажатую кнопку.
     *
     * @param {Object} event
     */
    applyCouponHandler: function (event) {
        "use strict";

        if (!!event) {
            // Блокируем стандартную отправку формы браузером
            event.preventDefault();

            let selectedCoupon;
            const $parentForm = window.mainJs.getClosest(event.target, "cart__tabs-form");
            if (!!$parentForm) {
                const $selectedCoupon = $parentForm.querySelector("input");
                if (!!$selectedCoupon) {
                    selectedCoupon = $selectedCoupon.value;
                }
            }

            if (selectedCoupon) {
                window.mainJs.showProgress(event.target);

                Cart.applyPromotion("coupon", selectedCoupon, false, window.obMindbox.personal.mindboxUserId)
                    .catch(function (error) {
                        window.console.log(error);
                    })
                    .finally(function () {
                        window.mainJs.hideProgress(event.target);
                    });
            } else {
                // Если поле для ввода купона пустое, выводим предупреждение
                const $blockCouponErrors = document.querySelector(".js-coupon-messages");
                if (!!$blockCouponErrors) {
                    window.mainJs.showInputMessage($blockCouponErrors, "Введите купон", true);
                }
            }
        }
    },
    /**
     * Функция добавляет обработчик кнопки отмены применения купона.
     */
    initClickCancelCoupon: function () {
        "use strict";

        const btnCancelCoupon = document.querySelectorAll(".js-unset-coupon");
        Array.prototype.forEach.call(btnCancelCoupon, function (btn) {
            btn.addEventListener("click", Cart.cancelCouponHandler);
        });
    },
    /**
     * Обработчик отмены применения купона.
     * Внимание! Рассчитано на то, что в разметке будет идти инпут, а за ним сразу кнопка
     *
     * @param {Object} event
     */
    cancelCouponHandler: function (event) {
        "use strict";

        if (!!event) {
            window.mainJs.showProgress(event.target);

            Cart.applyPromotion("coupon", "", true, window.obMindbox.personal.mindboxUserId)
                .then(function () {

                })
                .catch(function (error) {
                    window.console.log(error);
                })
                .finally(function () {
                    window.mainJs.hideProgress(event.target);
                });
        }
    },
    /**
     * Функция, которая меняет кнопку "Применить" на "Крестик" (для очистки поля ввода купона)
     * и обратно в зависимости от flag.
     *
     * @param {Object}  containerToInsert Элемент разметки (контейнер), в котором будет происходить замена кнопки
     * @param {boolean} flag              Если true - скрываем кнопку "Применить", показываем крестик
     */
    replacementButton: function (containerToInsert = null, flag = true) {
        if (flag) {
            // Скрываем кнопку "применить"
            try {
                if (containerToInsert) {
                    containerToInsert.querySelector(".flex-coupon__btn--success").style.display = "none";
                    if (containerToInsert.querySelector(".flex-coupon__btn--clear")) {
                        // Если крестик уже есть в разметке, то его делаем видимым
                        containerToInsert.querySelector(".flex-coupon__btn--clear").style.display = "flex";
                    } else {
                        // Если нет в разметке, то добавляем
                        let ClearBtn = document.createElement("button")
                        ClearBtn.innerHTML = "&#10006;";
                        ClearBtn.className = "flex-coupon__btn flex-coupon__btn--clear js-clear-coupon";
                        containerToInsert.querySelector(".flex-coupon").append(ClearBtn);
                        Cart.initClickReplacementButton();
                    }
                } else {
                    throw new Error("В функцию replacementButton переданы неверные(либо пустые) входные параметры")
                }
            } catch (error) {
                window.console.error(error);
            }
        } else {
            // Показываем кнопку "применить", скрываем крестик
            try {
                if (containerToInsert) {
                    containerToInsert.querySelector(".flex-coupon__btn--success").style.display = "flex";
                    containerToInsert.querySelector(".flex-coupon__btn--clear").style.display = "none";
                } else {
                    throw new Error("В функцию replacementButton переданы неверные(либо пустые) входные параметры")
                }
            } catch (error) {
                window.console.error(error);
            }
        }
    },
    /**
     * Метод выполняет применение купона или бонусов или отмену применения купона или бонусов
     *
     * @param type             Тип применяемого бонуса ("coupon" - купон; "bonus" - бонусные баллы)
     * @param requestPromotion Код купона или количество бонусных баллов, которые применяются
     * @param isCancel         Флаг, производится ли отмена применения
     * @param mindboxUserId    Идентификатор пользователя в mindbox
     */
    applyPromotion: function (type, requestPromotion, isCancel, mindboxUserId) {
        "use strict";

        return new Promise(function (resolve, reject) {
            let request = new XMLHttpRequest();

            let formData = new FormData();

            let isCoupon = "coupon" === type;
            let isBonus = "bonus" === type;

            if ((isCoupon && isBonus) || (!isCoupon && !isBonus)) {
                reject(new Error("Неправильный тип применяемого бонуса " + type));
            } else {
                formData.append("type", type);
                formData.append("requestPromotion", requestPromotion);
                formData.append("action", isCancel ? "cancel" : "apply");
                formData.append("mindboxUserId", mindboxUserId);

                request.open("POST", "/ajax/basket/set_mindbox_promotion.php", true);

                request.responseType = "json";

                request.send(formData);

                request.onload = function () {
                    const $blockMessages = document.querySelector(".js-" + type + "-messages");
                    if (request.readyState === 4 && request.status === 200) {
                        const jsonResponse = request.response;
                        if (jsonResponse.hasOwnProperty("success") && jsonResponse.success) {
                            if (jsonResponse.hasOwnProperty("appliedPromotion")) {
                                if (
                                    (
                                        jsonResponse.hasOwnProperty("is_promotion_applied")
                                        && jsonResponse.is_promotion_applied
                                    )
                                    || isCancel
                                ) {
                                    // Установим новые данные
                                    let dataItem = "";
                                    if (isCoupon) {
                                        dataItem = "data-user-coupon-code";
                                    } else if (isBonus) {
                                        dataItem = "data-user-used-bonus";
                                    }
                                    if (dataItem) {
                                        document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                            dataItem,
                                            jsonResponse.appliedPromotion
                                        );
                                    }

                                    // Купон или бонусы успешно применили: перезагружаем корзину
                                    window.basket.updateTotalBlock()
                                        .then(function () {
                                            // После перезагрузки затирается количество бонусов клиента.
                                            // Восстановим это значение по тем данным, которые были получены ранее.
                                            if (null !== Cart.maxUserBonusToCart) {
                                                document.getElementsByClassName("js-basket-data")[0].setAttribute(
                                                    "data-max-user-bonus-to-cart",
                                                    Cart.maxUserBonusToCart
                                                );
                                            }

                                            // Перезагрузка блока полей ввода купона и бонусов
                                            window.obMindbox.cart.initBonusInput();
                                        })
                                        .catch(function (error) {
                                            window.console.log(error);
                                        });
                                } else if (
                                    jsonResponse.hasOwnProperty("is_promotion_applied")
                                    && !jsonResponse.is_promotion_applied
                                ) {
                                    // Купон не был применён
                                    if (jsonResponse.hasOwnProperty("arErrors") && jsonResponse.arErrors.length) {
                                        // Выводим сообщение об ошибке
                                        window.mainJs.showInputMessage($blockMessages, jsonResponse.arErrors.join(), true);

                                        // Меняем цвет купона в инпуте
                                        const $inputCoupon = document.querySelector(".js-coupon-input");
                                        if (!!$inputCoupon) {
                                            Cart.changeInputColor($inputCoupon, "error");
                                        }
                                    }
                                }
                            } else if (jsonResponse.hasOwnProperty("arErrors") && jsonResponse.arErrors.length) {
                                // Купон (или бонусы) не был применён
                                if (jsonResponse.hasOwnProperty("arErrors") && jsonResponse.arErrors.length) {
                                    // Выводим сообщение об ошибке
                                    window.mainJs.showInputMessage($blockMessages, jsonResponse.arErrors.join(), true);
                                }
                            } else if (
                                jsonResponse.hasOwnProperty("arSuccessMessages")
                                && jsonResponse.arSuccessMessages.length
                            ) {
                                // Есть сообщения об успехах операций
                                if (
                                    jsonResponse.hasOwnProperty("arSuccessMessages")
                                    && jsonResponse.arSuccessMessages.length
                                ) {
                                    // Выводим сообщение об успешном применении
                                    window.mainJs.showInputMessage($blockMessages, jsonResponse.arSuccessMessages.join(), false);

                                    /*window.modal.showMessages(
                                        "notice",
                                        "Применение купона",
                                        [],
                                        jsonResponse.arSuccessMessages,
                                        []
                                    );*/
                                }
                            } else {
                                // Выводим сообщение об успешном применении
                                window.mainJs.showInputMessage($blockMessages, "Успешно", false);
                            }

                            window.obMindbox.cart.isNeedInitMindboxCart = true;

                            resolve(jsonResponse);
                        } else if (jsonResponse.hasOwnProperty("arErrors") && jsonResponse.arErrors.length) {
                            // Купон не был применён
                            if (jsonResponse.hasOwnProperty("arErrors") && jsonResponse.arErrors.length) {
                                // Выводим сообщение об ошибке
                                window.mainJs.showInputMessage($blockMessages, jsonResponse.arErrors.join(), true);

                                // скрываем кнопку "применить", показываем крестик
                                //Cart.replacementButton(Cart.containerToInsert);
                            }
                            // Запрос выполнился, но там какие-то ошибки
                            reject(new Error("В результате запроса получены ошибки"));
                        } else {
                            // Запрос выполнился, но там какие-то ошибки
                            reject(new Error("В результате запроса получены ошибки"));
                        }
                    } else {
                        // Запрос не выполнился
                        reject(new Error("Запрос не выполнился. " + request.status + ": " + request.statusText));
                    }
                }
            }
        });
    },
    /**
     * Функция добавляет обработчик на ввод в поле купона. Сбрасывает ошибку, если она была.
     */
    initChangeCouponInput: function () {
        "use strict";

        const $inputCoupon = document.querySelector(".js-coupon-input");
        if (!!$inputCoupon) {
            $inputCoupon.addEventListener("keyup", function (event) {
                // Очищаем цвет ошибки, если он был
                Cart.changeInputColor(event.target, "default");

                const $blockMessages = document.querySelector(".js-coupon-messages");
                if (!!$blockMessages) {
                    window.mainJs.showInputMessage($blockMessages, "", null);
                }
            });
        }
    },
    /**
     * Функция добавляет обработчик на ввод в поле бонусов. Сбрасывает ошибку, если она была.
     */
    initChangeBonusInput: function () {
        "use strict";

        const $inputBonus = document.querySelector(".js-bonus-input");
        if (!!$inputBonus) {
            $inputBonus.addEventListener("keyup", function (event) {
                // Очищаем цвет ошибки, если он был
                Cart.changeInputColor(event.target, "default");

                const $blockMessages = document.querySelector(".js-bonus-messages");
                if (!!$blockMessages) {
                    window.mainJs.showInputMessage($blockMessages, "", null);
                }
            });
        }
    },
    /**
     * Функция добавляет обработчик на крестик (очистка поля ввода купона)
     */
    initClickReplacementButton: function () {
        "use strict";

        const clearButton = document.querySelector(".js-clear-coupon");
        if (!!clearButton) {
            clearButton.addEventListener("click", function (event) {
                // очищаем поле
                event.target.parentElement.firstElementChild.value = "";
                // очищаем блок с выводом сообщений
                window.mainJs.showInputMessage(Cart.containerForMessage, "", null);
                // скрываем крестик, показываем кнопку "применить"
                Cart.replacementButton(Cart.containerToInsert, false);
            });
        }
    },
    /**
     * Функция добавляет обработчик кнопки применения бонусов.
     */
    initClickApplyBonus: function () {
        "use strict";

        const btnApplyBonus = document.querySelectorAll(".js-set-bonus");
        Array.prototype.forEach.call(btnApplyBonus, function (btn) {
            btn.addEventListener("click", Cart.applyBonusHandler);
        });
    },
    /**
     * Обработчик применения бонусов.
     * Внимание! Рассчитано на то, что в разметке будет идти инпут, а за ним сразу кнопка
     *
     * @param {Object} event
     */
    applyBonusHandler: function (event) {
        "use strict";

        if (!!event) {
            // Блокируем стандартную отправку формы браузером
            event.preventDefault();

            let selectedBonus;
            const $parentForm = window.mainJs.getClosest(event.target, "cart__tabs-form");
            if (!!$parentForm) {
                const $selectedBonusInput = $parentForm.querySelector("input");
                if (!!$selectedBonusInput) {
                    selectedBonus = $selectedBonusInput.value;
                }
            }
            if (selectedBonus > 0) {
                window.mainJs.showProgress(event.target);

                Cart.applyPromotion("bonus", selectedBonus, false, window.obMindbox.personal.mindboxUserId)
                    .then(function () {

                    })
                    .catch(function (error) {
                        window.console.log(error);
                    })
                    .finally(function () {
                        window.mainJs.hideProgress(event.target);
                    });
            }
        }
    },
    /**
     * Функция добавляет обработчик кнопки отмены применения бонусных баллов.
     */
    initClickCancelBonus: function () {
        "use strict";

        const btnCancelBonus = document.querySelectorAll(".js-unset-bonus");
        Array.prototype.forEach.call(btnCancelBonus, function (btn) {
            btn.addEventListener("click", Cart.cancelBonusHandler);
        });
    },
    /**
     * Обработчик отмены применения бонусных баллов.
     * Внимание! Рассчитано на то,
     * что в разметке будет идти инпут, а за ним сразу кнопка
     *
     * @param {Object} event
     */
    cancelBonusHandler: function (event) {
        "use strict";

        if (!!event) {
            window.obMindbox.addLoadingToBtn(event.target);

            Cart.applyPromotion("bonus", "", true, window.obMindbox.personal.mindboxUserId)
                .then(function () {

                })
                .catch(function (error) {
                    window.console.log(error);
                })
                .finally(function () {
                    window.obMindbox.removeLoadingFromBtn(event.target);
                });
        }
    },
    /**
     * Изменение цвета текста внутри инпута. Нужно для подсветки ошибки и сброса ошибки.
     *
     * @param {Object} $input    Элемент DOM (input), в котором меняем цвет
     * @param {string} typeColor Тип цветового выделения. Возможны два значения: "error" - для ошибочного значения
     *                           и "default" - для обычного цвета
     */
    changeInputColor: function ($input, typeColor) {
        "use strict";

        if (!!$input && typeColor) {
            if ("error" === typeColor) {
                $input.classList.add("flex-message--error");
            } else if ("default" === typeColor) {
                $input.classList.remove("flex-message--error");
            }
        }
    },
    /**
     * Метод возвращает объект со всеми данными программы лояльности из данных data атрибутов корзины
     */
    getBasketData: function () {
        "use strict";

        let result = {};
        const basketDataElement = document.getElementsByClassName("js-basket-data")[0];
        if (basketDataElement) {
            result = {
                "isBasketChanged": basketDataElement.dataset.isBasketChanged,
                "isCanUseBoth": basketDataElement.dataset.isCanUseBoth,
                "isCanUseCoupon": basketDataElement.dataset.isCanUseCoupon,
                "isCanUseBonus": basketDataElement.dataset.isCanUseBonus,
                "isCouponSelected": basketDataElement.dataset.isCouponSelected,
                "isSpendBonusSelected": basketDataElement.dataset.isSpendBonusSelected,
                "userCouponCode": basketDataElement.dataset.userCouponCode,
                "userUsedBonus": basketDataElement.dataset.userUsedBonus,
                "bonusAccountCode": basketDataElement.dataset.bonusAccountCode,
                "maxUserBonusToCart": basketDataElement.dataset.maxUserBonusToCart,
                "isCanEarnBonusPoints": basketDataElement.dataset.isCanEarnBonusPoints,
                "isUserAuthorized": basketDataElement.dataset.isUserAuthorized,
                "bonusToEarn": basketDataElement.dataset.bonusToEarn,
                "isMindboxBonusProgram": basketDataElement.dataset.isMindboxBonusProgram
            };
        }

        return result;
    }
};
export {
    Cart
}
